import { createFileRoute } from "@tanstack/react-router";
import OptionCatalogPage from "lib/components/options/catalog/search/OptionCatalogPage";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../components/withAuthentication";

function OptionCatalog() {
  const { builderId } = useAppRouterParams();
  if (!builderId) {
    return null;
  }
  return <OptionCatalogPage builderId={builderId} />;
}

export const Route = createFileRoute("/builders/$builder_id/options/")({
  component: withAuthentication(OptionCatalog, {
    permissions: ["VIEW_OPTION_CATALOG"],
    features: ["nextGenOptions"],
  }),
});
